import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../utils';

// Fetch logs directly from backend
export const fetchLogs = createAsyncThunk(
    'logs/fetchLogs',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiFetch('api/haki/dashboard/logs');
            if (!response.ok) {
                return rejectWithValue('Failed to fetch logs');
            }

            const data = await response.json();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const logsSlice = createSlice({
    name: 'logs',
    initialState: {
        logs: [],
        loading: false,
        error: null,
    },
    reducers: {
        addLog: (state, action) => {
            state.logs.unshift(action.payload);
        },
        clearLogs: (state) => {
            state.logs = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLogs.fulfilled, (state, action) => {
                state.loading = false;
                state.logs = action.payload || [];
            })
            .addCase(fetchLogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to load logs';
            });
    },
});

export const { addLog, clearLogs } = logsSlice.actions;
export default logsSlice.reducer;
